import { Colors, ImageFrames, StoreData as StoreDataType, StoreTheme } from '@/types/store';
import z from 'zod';
import {
    EditorialTextItemSchema,
    GalleryItemSchema,
    HeaderItemSchema,
    PageItemSchema,
    PendingItemSchema,
    SectionItemSchema,
    StoreItemSchema,
    TestimonialsItemSchema,
    TitleItemSchema,
} from '../schema/store';

export enum ItemType {
    HEADER = 'header',
    PENDING = 'pending',
    PAGE = 'page',
}

/** Main StoreItem type - discriminated union of all item types */
export type StoreItem = z.infer<typeof StoreItemSchema>;

/** Individual item types for explicit narrowing */
export type EditorialTextItem = z.infer<typeof EditorialTextItemSchema>;
export type GalleryItem = z.infer<typeof GalleryItemSchema>;
export type TestimonialsItem = z.infer<typeof TestimonialsItemSchema>;
export type TitleItem = z.infer<typeof TitleItemSchema>;
export type PageItem = z.infer<typeof PageItemSchema>;
export type PendingItem = z.infer<typeof PendingItemSchema>;
export type HeaderItem = z.infer<typeof HeaderItemSchema>;

/** Union type for all section items (excludes PAGE, PENDING, HEADER) */
export type SectionItem = z.infer<typeof SectionItemSchema>;

// Store data types
export type StoreData = {
    items?: StoreItem[];
    isDirty?: boolean;
} & StoreDataType;

// Configuration types
export interface CustomizationsConfiguration {
    theme: StoreTheme;
    fonts: {
        primary: Fonts;
        secondary: SecondaryFonts;
    };
    colors: Colors;
    imageFrames: ImageFrames;
}

export enum Fonts {
    BEBAS_NEUE = 'Bebas Neue',
    SPICY_RICE = 'Spicy Rice',
    LORA = 'Lora',
    PLAYFAIR_DISPLAY = 'Playfair Display',
    FJALLA_ONE = 'Fjalla One',
    BRIOLAGE_GROTESQUE = 'Bricolage Grotesque',
}

export enum SecondaryFonts {
    ROBOTO = 'Roboto',
    INTER = 'Inter',
    WORK_SANS = 'Work Sans',
}

// Order item types (for API calls)
export interface PageOrderItem {
    page_id: number;
    order: number;
}

export interface SectionOrderItem {
    section_id: number;
    order: number;
}
